var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnbLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0C31.0465 0 40 8.95353 40 20C40 31.0465 31.0465 40 20 40C8.95353 40 0 31.0465 0 20C0 8.95353 8.95353 0 20 0Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "bnb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.992 20.0004L11.0064 25.2889L15.5 27.9331V31.0293L8.3766 26.8514V18.454L10.992 20.0004ZM10.992 14.712V17.7937L8.375 16.2456V13.1639L10.992 11.6158L13.6218 13.1639L10.992 14.712ZM17.3766 13.1639L19.9936 11.6158L22.6234 13.1639L19.9936 14.712L17.3766 13.1639Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.8848 24.1927V21.0966L15.5018 22.6447V25.7264L12.8848 24.1927ZM17.3784 29.0421L19.9953 30.5902L22.6251 29.0421V32.1238L19.9953 33.6719L17.3784 32.1238V29.0421ZM26.3784 13.1639L28.9953 11.6158L31.6252 13.1639V16.2456L28.9953 17.7937V14.712L26.3784 13.1639ZM28.9953 25.2889L29.0098 20.0004L31.6268 18.4524V26.8498L24.5034 31.0277V27.9315L28.9953 25.2889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M27.117 24.1926L24.5 25.7262V22.6445L27.117 21.0964V24.1926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.1187 15.8073L27.1332 18.9034L22.6268 21.5477V26.849L20.0098 28.3826L17.3928 26.849V21.5477L12.8864 18.9034V15.8073L15.5146 14.2592L19.9937 16.9163L24.5001 14.2592L27.13 15.8073H27.1187ZM12.8848 10.5204L19.9953 6.32812L27.1187 10.5204L24.5018 12.0685L19.9953 9.41146L15.5018 12.0685L12.8848 10.5204Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbLogo);
export default __webpack_public_path__ + "static/media/bnb-logo.2c121444f35749b2652b6b666d6d0234.svg";
export { ForwardRef as ReactComponent };